import React from 'react';

import HeaderDropdownLinks from './menu/index';
import HeaderProfileDropdown from './profile';
import s from './styles.module.scss';

import type { IDropdownLinks } from '../types';

interface IProps {
  links: IDropdownLinks[];
  showNavigation: boolean;
}

const DesktopHeader: React.FC<IProps> = ({ links, showNavigation }) => {
  return (
    <nav>
      <ul className={s.links}>
        {showNavigation &&
          links.map((link) => (
            <HeaderDropdownLinks key={link.label} data={link} />
          ))}
        <li className={s.profile}>
          <HeaderProfileDropdown />
        </li>
      </ul>
    </nav>
  );
};

export default DesktopHeader;
